import { computed } from 'vue';

import ViktorClient from '@/api/clients/viktorClient/ViktorClient';
/* STORE */
import { useAuthStore } from '@/stores/auth';
/* TYPES */
import type { UserSearchResponse } from '@/types/api/user/user';

/**
 * Elastic search for users in recruiter's sharepool
 *
 * @param {string} query Searched query
 * @returns users from requested query
 */
export function getSearchedUsers(query: string): Promise<UserSearchResponse> {
  const sharepoolSpace = computed(() => useAuthStore().getSharepoolSpace);
  const params = {
    per_page: 30,
    query: query.trim(),
    sharepool_uuid: sharepoolSpace.value
  };
  return ViktorClient().get(`/search/users`, { params });
}
